var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import MetricsReporter from '@cdo/apps/lib/metrics/MetricsReporter';
/**
 * Singleton metrics reporter for Lab2 labs.
 */
var Lab2MetricsReporter = /** @class */ (function () {
    function Lab2MetricsReporter() {
        // Common fields that are added to every log payload.
        this.commonProperties = {};
    }
    /**
     * Update common properties that will be added to log payloads.
     * Provided properties will be merged with existing properties,
     * so single properties can be updated without overwriting others.
     */
    Lab2MetricsReporter.prototype.updateProperties = function (properties) {
        this.commonProperties = __assign(__assign({}, this.commonProperties), properties);
    };
    Lab2MetricsReporter.prototype.logInfo = function (message) {
        MetricsReporter.logInfo(this.decorateMessage(message));
    };
    Lab2MetricsReporter.prototype.logWarning = function (message) {
        MetricsReporter.logWarning(this.decorateMessage(message));
    };
    Lab2MetricsReporter.prototype.logError = function (errorMessage, error, details) {
        var message = {
            errorMessage: errorMessage,
            error: (error === null || error === void 0 ? void 0 : error.stack) || (error === null || error === void 0 ? void 0 : error.message),
            details: details,
        };
        MetricsReporter.logError(this.decorateMessage(message));
    };
    Lab2MetricsReporter.prototype.reportLoadTime = function (metricName, loadTimeMs, dimensions) {
        if (dimensions === void 0) { dimensions = []; }
        MetricsReporter.publishMetric(metricName, loadTimeMs, 'Milliseconds', __spreadArray(__spreadArray([], dimensions, true), this.getCommonDimensions(), true));
    };
    Lab2MetricsReporter.prototype.reportSevereError = function (dimensions) {
        if (dimensions === void 0) { dimensions = []; }
        MetricsReporter.incrementCounter('SevereError', __spreadArray(__spreadArray([], dimensions, true), this.getCommonDimensions(), true));
    };
    Lab2MetricsReporter.prototype.reset = function () {
        this.commonProperties = {};
    };
    Lab2MetricsReporter.prototype.decorateMessage = function (message) {
        if (typeof message === 'string') {
            message = {
                message: message,
            };
        }
        return __assign(__assign({}, message), this.commonProperties);
    };
    /**
     * Get a list of common dimensions for every Lab metric event.
     */
    Lab2MetricsReporter.prototype.getCommonDimensions = function () {
        var dimensions = [];
        if (this.commonProperties.appName) {
            dimensions.push({
                name: 'AppName',
                value: this.commonProperties.appName,
            });
        }
        return dimensions;
    };
    return Lab2MetricsReporter;
}());
export default new Lab2MetricsReporter();
